import React from 'react';
/*
  Required argument: formInputMappings (object):
    keys are the input field names and values are the input field values;
    values must be strings or numbers
  Returns an array of JSX hidden inputs with specified names and values
*/

const buildHiddenInputs = formInputMappings => (
  Object.keys(formInputMappings)
    .filter(fieldName => formInputMappings[fieldName] != null
            && typeof formInputMappings[fieldName] != 'object')
    .map((fieldName, index) => (
      <input key={ index } type="hidden" name={ fieldName }
              value={ formInputMappings[fieldName] } />
    ))
);

export default buildHiddenInputs;
